<script setup lang="ts">
// No props needed for this component
</script>

<template>
  <footer
    class="navigation-footer d-flex justify-content-between p-3 border-top"
  >
    <button class="btn btn-link text-dark">
      <i class="bi bi-chevron-left"></i>
    </button>

    <button class="btn btn-link text-dark">
      <i class="bi bi-circle-fill"></i>
    </button>

    <button class="btn btn-link text-dark">
      <i class="bi bi-square"></i>
    </button>
  </footer>
</template>

<style scoped>
.navigation-footer {
  background-color: #ffffff;
}

.btn-link {
  text-decoration: none;
  font-size: 24px;
}
</style>
